import { yupResolver } from '@hookform/resolvers/yup';

import { passwordTest } from 'lib/yup/helpers';
import * as yup from 'yup';

import { RecoverPassFormFields } from './types';

const password = yup.string().trim().default('').required().test(passwordTest);

const recoverPassFormValidationSchema: yup.ObjectSchema<RecoverPassFormFields> = yup
    .object()
    .shape({
        email: yup.string().email().required(),
        password,
    })
    .required();

export const recoverPassFormResolver = yupResolver(
    recoverPassFormValidationSchema,
);
